import React from "react";
import "../ComponentsCSS/Services.css";
import PricingSection from "./Pricing";
import Form from "./Form.jsx";
import { Link } from "react-router-dom";
import SEO from "./SEO";

const Study = () => {
  return (
    <>
      <SEO
        title="Our Shuttle Services | SASK A One Shuttle | Special Needs Transport"
        description="Explore our shuttle services in Saskatchewan: special needs wheelchair transport, medical courier, airport transfers, and long-distance travel."
        keywords="special needs transportation Prince Albert, medical courier Saskatchewan, airport transfers Saskatchewan, wheelchair van Prince Albert"
      />
      <div
        className="container-fluid my-5 py-5 text-center services-page"
        data-aos="fade-up"
      >
        <h1 data-aos="zoom-in">Services</h1>
        <p data-aos="zoom-in">Home / Our Services</p>
      </div>

      <div className="container services-content mt-5">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-md-6 order-2 order-md-1 mt-5 text-center"
            data-aos="fade-left"
          >
            <h3>Special Needs Transportation</h3>
            <p>
              All sorts of wheelchairs, Broda chair, electric and manual chair
              delivery and transportation
            </p>
          </div>
          <div
            className="col-md-6 order-1 order-md-2 text-center"
            data-aos="zoom-out"
          >
            <img src="./assets/services1.png" alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container services-content mt-5">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-md-6 order-1 order-md-1 text-center"
            data-aos="flip-right"
          >
            <img src="./assets/services2.avif" alt="" className="img-fluid" />
          </div>
          <div
            className="col-md-6 order-2 order-md-2 mt-5 text-center"
            data-aos="fade-left"
          >
            <h3>Medical Equipments</h3>
            <p>
              All medical supplies and equipment such as oxygen tank and
              sensitive drugs
            </p>
          </div>
        </div>
      </div>

      <div className="container services-content mt-5">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-md-6 order-2 order-md-1 mt-5 text-center"
            data-aos="fade-left"
          >
            <h3>Medical/ Couriers Services</h3>
            <p>
              Special needs transport and all kinds of assisting for
              transportation
            </p>
            <p>
              Ride for family and friends who accompanying the client as
              caregiver or nurse
            </p>
          </div>
          <div
            className="col-md-6 order-1 order-md-2 text-center"
            data-aos="slide-up"
          >
            <img src="./assets/services3.avif" alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container services-content mt-5">
        <div className="row align-items-center justify-content-center">
        <div
  className="col-md-6 order-1 order-md-1 text-center map"
  data-aos="flip-left"
>
  <iframe
    src="https://maps.google.com/maps?q=75%20South%20Industrial%20Drive,%20Prince%20Albert,%20SK%20S6V%207L7&t=&z=15&ie=UTF8&iwloc=&output=embed"
    width="100%"
    height="450"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="SASK A One Shuttle Location Map"
  />
</div>
          <div
            className="col-md-6 order-2 order-md-2 mt-5 text-center online"
            data-aos="fade-left"
          >
            <h3 data-aos="slide-up">
              SASK A One <span>Shuttle</span>
            </h3>
            <p data-aos="fade-left">
              Ride with SASK A One Shuttle from anywhere, to anywhere in
              Prince Albert. Whether you need airport transportation or a ride
              across town, Comfort Shuttle can get you there safely and on time.
            </p>
            <h3 data-aos="fade-right">Call Us Now</h3>
            <h3 data-aos="fade-up">
              <i className="fa fa-phone"></i> +1 (639) 470-2917
            </h3>
            <Link data-aos="fade-up" to="/contact" className="book-button">
              Online Booking
            </Link>
          </div>
        </div>
      </div>
      <PricingSection />
      <Form />
    </>
  );
};

export default Study;
